import { JSX, useMemo } from "react";
import StatusLabel from "./StatusLabel";

import RenderCheckList from "./RenderCheckList";
import GlobalStyle from "../../styles/GlobalStyle";
import {
  scaleVertical,
  scaleHorizontal,
  FontSizes,
  scaleModerate,
} from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { PALLETTE } from "../../utils/theme";
import { ReortLabels } from "../../utils/helpers/newReportHelper";
import { SearchteethIconSvg } from "../../utils/Svgs";
import MultilineTextBox from "./MultilineTextBox";

const ComplaintsCard = ({
  imageSource,
  topLefticon,
  title,
  suggestionText,
  data,
  remark,
  label = "Normal",
}: {
  imageSource?: any;
  topLefticon?: JSX.Element | null;
  title?: string;
  suggestionText?: string;
  data: any;
  remark?: string;
  label?: any;
}) => {
  const ClinicalExaminationData = useMemo(() => {
    return Object.entries(data || {}).map(([key, isChecked]) => ({
      title: ReortLabels[key],
      isChecked,
      ailmentKey: key,
    }));
  }, [data]);

  return (
    <div style={{ ...V2ReportStyle.card, gap: scaleVertical(10) }}>
      <div
        style={{
          ...V2ReportStyle.flexRowCenter,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(2) }}
        >
          {topLefticon}
          <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2.2rem" }}>
            {title}
          </span>
        </div>
        <StatusLabel lable={label} />
      </div>

      {/* row 2 */}
      <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(10) }}>
        {imageSource && (
          <img
            src={imageSource}
            alt="Clinical visual"
            style={{
              width: scaleModerate(60),
              height: scaleModerate(60),
              objectFit: "contain",
            }}
          />
        )}
        <div
          style={{
            ...V2ReportStyle.card,
            backgroundColor: PALLETTE.grayOpaque,
            padding: scaleModerate(10),
            flex: 1,
            gap: scaleVertical(5),
          }}
        >
          {ClinicalExaminationData?.map((item, index) => {
            return (
              <RenderCheckList
                key={index}
                ailmentKey={item?.ailmentKey}
                {...item}
              />
            );
          })}
        </div>
      </div>

      {/* row 3 */}
      {suggestionText ? (
        <div style={{ ...V2ReportStyle.flexRowCenter }}>
          <span
            style={{
              ...GlobalStyle.blackMediumText,
              fontSize: "2rem",
            }}
          >
            {suggestionText}
          </span>
        </div>
      ) : null}

      {/* row 4 */}
      {remark ? (
        <MultilineTextBox
          label="Doctor’s Remarks"
          icon={<SearchteethIconSvg />}
          description={remark}
        />
      ) : null}
    </div>
  );
};

export default ComplaintsCard;
